// File: src/pages/reports/GSTR1.jsx
import React, { useEffect, useMemo, useState, useDeferredValue } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import swal from "sweetalert";
import moment from "moment";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ImDownload } from "react-icons/im";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import { ToWords } from "to-words";

import SuperAdminUI from "../import/SuperAdminUI";
import { CheckPermission } from "../import/CheckPermission";
import Logo from "../import/logowithoutback.png";
import {
  _Post,
  _GetById,
  createOrderhistoryviewDATABASE,
} from "../import/ApiEndPoint/ApiCalling";
import {
  CDNR_Report,
  View_Invoice_Data_by_id,
} from "../import/ApiEndPoint/Api";
import LastestInvoice from "./LastestInvoice";

/* ---------------- inline CSS ---------------- */
const injectOnce = () => {
  if (document.getElementById("gstr1-inline-css-simple-v2")) return;
  const style = document.createElement("style");
  style.id = "gstr1-inline-css-simple-v2";
  style.innerHTML = `
    .g1-card{
      border:1px solid #e5e7eb;
      border-radius:16px;
      background:#fff;
      box-shadow:0 6px 18px rgba(15,23,42,.05);
    }
    .g1-toolbar{
      display:flex;
      align-items:center;
      gap:10px;
      flex-wrap:nowrap;
      overflow-x:auto;
      padding:10px 12px;
    }
    .g1-toolbar::-webkit-scrollbar{height:6px}
    .g1-toolbar::-webkit-scrollbar-thumb{background:#e5e7eb;border-radius:999px}
    .g1-tabs{
      display:flex;
      gap:8px;
      align-items:center;
      white-space:nowrap;
    }
    .g1-tab{
      border:1px solid #e5e7eb;
      background:#fff;
      border-radius:999px;
      padding:7px 12px;
      font-weight:800;
      font-size:13px;
      cursor:pointer;
      user-select:none;
      transition:all .12s ease;
      color:#0f172a;
      white-space:nowrap;
    }
    .g1-tab.active{
      background:#2563eb;
      border-color:#2563eb;
      color:#fff;
      box-shadow:0 12px 22px rgba(37,99,235,.25);
    }
    .g1-field{
      display:flex;
      flex-direction:column;
      gap:4px;
      min-width:160px;
    }
    .g1-field.wide{min-width:210px}
    .g1-label{
      font-size:11px;
      color:#64748b;
      font-weight:800;
      text-transform:uppercase;
      margin:0;
      line-height:1;
      white-space:nowrap;
    }
    .g1-input{
      height:34px !important;
      border-radius:12px !important;
      border:1px solid #e5e7eb !important;
      padding:6px 10px !important;
      background:#fff !important;
    }
    .g1-pill{
      display:inline-flex;
      align-items:center;
      justify-content:center;
      height:34px;
      padding:0 12px;
      border-radius:999px;
      border:1px solid #e5e7eb;
      background:#f8fafc;
      font-weight:900;
      color:#0f172a;
      white-space:nowrap;
    }
    .g1-spacer{flex:1; min-width:16px}

    .g1-section-card{
      border:1px solid #e5e7eb;
      border-radius:14px;
      background:#fff;
      padding:8px;
    }
    .g1-section-title{
      font-weight:800;
      font-size:16px;
      margin:10px 0 8px 0;
      display:flex;
      align-items:center;
      gap:8px;
    }
    .g1-section-title .pill{
      background:#eef2ff;
      color:#3730a3;
      font-weight:700;
      padding:2px 8px;
      border-radius:999px;
      font-size:12px;
    }

    .g1-table-wrap{
      width:100%;
      overflow:auto;
      border:1px solid #e5e7eb;
      border-radius:14px;
      background:#fff;
    }
    .g1-table{
      width:100%;
      border-collapse:collapse;
      min-width:1200px;
    }
    .g1-table thead th{
      background:#f4f7f6;
      color:#0f172a;
      font-weight:700;
      text-transform:uppercase;
      font-size:12px;
      letter-spacing:.03em;
      border-bottom:1px solid #e5e7eb;
      padding:6px 8px;
      position:sticky;
      top:0;
      z-index:1;
      text-align:center;
      white-space:nowrap;
    }
    .g1-table tbody td{
      padding:8px 10px;
      border-bottom:1px solid #f1f5f9;
      vertical-align:middle;
      color:#0f172a;
      font-size:14px;
      text-align:center;
    }
    .g1-table tbody tr:hover{background:#f9fbff}

    .g1-month-row{
      background:#eef6ff !important;
      font-weight:900;
      cursor:pointer;
    }
    .g1-month-row:hover{
      background:#e4efff !important;
    }
    .g1-month-cell{
      display:flex;
      align-items:center;
      gap:8px;
      justify-content:flex-start;
    }
    .g1-month-muted{
      color:#64748b;
      font-weight:700;
    }
    .g1-final-row td{
      font-weight:800;
      background:#fafafa;
    }
    .g1-link{
      color:#1d4ed8;
      text-decoration:underline;
      cursor:pointer;
      font-weight:700;
    }

    .g1-dl{
      position:relative;
    }
    .g1-dl-menu{
      position:absolute;
      right:0;
      top:30px;
      z-index:10;
      border:1px solid rgb(8,91,245);
      background:#fff;
      border-radius:10px;
      overflow:hidden;
      min-width:140px;
      box-shadow:0 12px 24px rgba(0,0,0,.12);
    }
    .g1-dl-item{
      padding:10px 12px;
      cursor:pointer;
      font-weight:600;
      letter-spacing:.02em;
    }
    .g1-dl-item:hover{background:#f1f5ff}
    .g1-download-gstr1{
      height:34px;
      border-radius:12px !important;
      display:inline-flex !important;
      align-items:center;
      justify-content:center;
      gap:8px;
      padding:0 14px !important;
      font-weight:800 !important;
      white-space:nowrap;
      box-shadow:0 8px 18px rgba(37,99,235,.18);
    }

    .g1-sum-bar{
      border:1px solid #e5e7eb;
      border-radius:12px;
      background:#fff;
      padding:10px;
      margin:6px 0;
    }
    .g1-sum-grid{
      display:grid;
      grid-template-columns:repeat(6,minmax(120px,1fr));
      gap:8px;
    }
    .g1-sum-box{
      border:1px solid #e5e7eb;
      border-radius:10px;
      padding:8px;
      background:#f9fafb;
    }
    .g1-sum-k{
      font-size:12px;
      color:#6b7280;
    }
    .g1-sum-v{
      font-weight:800;
    }
    .g1-error{
      border:1px solid #fecaca;
      background:#fee2e2;
      color:#991b1b;
      border-radius:10px;
      padding:8px 12px;
      font-weight:800;
      letter-spacing:.04em;
      text-align:center;
    }
  `;
  document.head.appendChild(style);
};

/* ---------------- helpers ---------------- */
const dateOnly = (s) => (s ? String(s).split("T")[0] : "");
const toStr = (v) => (v == null ? "" : String(v));
const N = (v) => (isNaN(Number(v)) ? 0 : Number(v));
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const money = (v) => round2(v).toFixed(2);
const isCompletedStatus = (status) =>
  String(status || "")
    .trim()
    .toLowerCase() === "completed";

const getFYStartYear = (d = new Date()) => {
  const dt = new Date(d);
  const y = dt.getFullYear();
  const m = dt.getMonth();
  return m >= 3 ? y : y - 1;
};

const fyLabel = (startYear) => {
  const endYY = String((startYear + 1) % 100).padStart(2, "0");
  return `FY ${startYear}-${endYY}`;
};

const FY_MONTHS = [
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
];

const FY_QUARTERS = [
  { value: "Q1", label: "Q1 (Apr-Jun)", months: [4, 5, 6] },
  { value: "Q2", label: "Q2 (Jul-Sep)", months: [7, 8, 9] },
  { value: "Q3", label: "Q3 (Oct-Dec)", months: [10, 11, 12] },
  { value: "Q4", label: "Q4 (Jan-Mar)", months: [1, 2, 3] },
];

const FY_HALVES = [
  { value: "H1", label: "H1 (Apr-Sep)", months: [4, 5, 6, 7, 8, 9] },
  { value: "H2", label: "H2 (Oct-Mar)", months: [10, 11, 12, 1, 2, 3] },
];

const FY_MONTH_ORDER = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

const buildInvoiceNumber = (invoiceId) => {
  const companyDetails = JSON.parse(
    localStorage.getItem("Companydetail") || "{}",
  );
  const prefix = companyDetails.Prefix || "";
  const suffix = companyDetails.Suffix || "";
  return invoiceId ? `${prefix}${invoiceId}${suffix}` : "-";
};

const getSupplierStateCode = () => {
  const comp = JSON.parse(localStorage.getItem("Companydetail") || "{}");
  const gst = comp?.gstNo || comp?.gst || "";
  return gst ? gst.slice(0, 2) : "";
};

const getSelectedDatabase = (user = {}) => {
  const baseDatabase =
    user?.database ||
    user?.Database ||
    localStorage.getItem("database") ||
    localStorage.getItem("Database") ||
    "";

  const financialYearSelected = localStorage.getItem("financialYearSelected");

  if (!baseDatabase) return "";

  return financialYearSelected
    ? `${baseDatabase}-${financialYearSelected}`
    : baseDatabase;
};

const getSelectedFinancialYear = () =>
  String(localStorage.getItem("financialYearSelected") || "").trim();

const getSelectedFYStartYear = () => {
  const fy = getSelectedFinancialYear().replace(/^FY\s*/i, "");
  const start = Number(String(fy || "").split("-")[0]);

  return Number.isFinite(start) && start > 0
    ? start
    : getFYStartYear(new Date());
};

const getPartyStateCode = (party = {}) => {
  const gst = party?.gstNumber || "";
  return gst ? gst.slice(0, 2) : "";
};

const isInterStateFromOrder = (order, partyStateCode, supplierStateCode) => {
  if (order?.igstTaxType === true) return true;
  if (order?.igstTaxType === false) return false;
  if (partyStateCode && supplierStateCode) {
    return partyStateCode !== supplierStateCode;
  }
  return false;
};

function inFinancialPeriod(
  dateValue,
  fyStartYear,
  filterType,
  month,
  quarter,
  half,
  startDate,
  endDate,
) {
  const d = dateValue ? new Date(dateValue) : null;
  if (!d || Number.isNaN(d.getTime())) return false;

  const only = dateOnly(d.toISOString());

  if (filterType === "date") {
    return (!startDate || only >= startDate) && (!endDate || only <= endDate);
  }

  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  const rowFY = m >= 4 ? y : y - 1;

  if (rowFY !== Number(fyStartYear)) return false;

  if (filterType === "month") return m === Number(month);

  if (filterType === "quarter") {
    const q = FY_QUARTERS.find((x) => x.value === quarter);
    return q ? q.months.includes(m) : true;
  }

  if (filterType === "half") {
    const h = FY_HALVES.find((x) => x.value === half);
    return h ? h.months.includes(m) : true;
  }

  return true;
}

function formatCurrentRangeLabel(
  filterType,
  fyStartYear,
  month,
  quarter,
  half,
  startDate,
  endDate,
) {
  if (filterType === "date") {
    const txt = `${startDate || ""}${startDate || endDate ? " to " : ""}${endDate || ""}`;
    return txt || "All Dates";
  }
  if (filterType === "month") {
    const m = FY_MONTHS.find((x) => x.value === Number(month));
    return `${fyLabel(Number(fyStartYear))} / ${m?.label || ""}`;
  }
  if (filterType === "quarter") {
    const q = FY_QUARTERS.find((x) => x.value === quarter);
    return `${fyLabel(Number(fyStartYear))} / ${q?.label || ""}`;
  }
  if (filterType === "half") {
    const h = FY_HALVES.find((x) => x.value === half);
    return `${fyLabel(Number(fyStartYear))} / ${h?.label || ""}`;
  }
  return fyLabel(Number(fyStartYear));
}

function getMonthNameFromDate(d) {
  return new Date(d).toLocaleString("en-IN", { month: "long" });
}

function getMonthSortIndex(monthName) {
  const i = FY_MONTH_ORDER.indexOf(monthName);
  return i >= 0 ? i : 999;
}

function getMonthLabelFromDate(dateValue, fyStartYear) {
  const d = new Date(dateValue);
  const monthName = getMonthNameFromDate(d);
  const month = d.getMonth() + 1;
  const year = month >= 4 ? fyStartYear : fyStartYear + 1;
  return `${monthName} ${year}`;
}

function buildGroupKey(dateValue, fyStartYear) {
  const monthName = getMonthNameFromDate(dateValue);
  return `${fyStartYear}__${monthName}`;
}

function groupRowsByMonth(list = [], fyStartYear, sectionKey = "GROUP") {
  const map = new Map();

  list.forEach((row) => {
    const rowDate = row?.order?.date || row?.date || row?.createdAt;
    const key = `${sectionKey}__${buildGroupKey(rowDate, fyStartYear)}`;
    const monthName = getMonthNameFromDate(rowDate);

    if (!map.has(key)) {
      map.set(key, {
        key,
        monthName,
        monthLabel: getMonthLabelFromDate(rowDate, fyStartYear),
        rows: [],
      });
    }

    map.get(key).rows.push(row);
  });

  const groups = Array.from(map.values()).map((g) => {
    const sortedRows = [...g.rows].sort((a, b) => {
      const da = new Date(a?.order?.date || 0).getTime();
      const db = new Date(b?.order?.date || 0).getTime();
      if (da !== db) return db - da;
      return N(b?.order?.invoiceId) - N(a?.order?.invoiceId);
    });

    return {
      ...g,
      rows: sortedRows,
      totals: {
        taxableAmount: round2(
          sortedRows.reduce((acc, r) => acc + N(r?.taxableAmount), 0),
        ),
        cgstTotal: round2(
          sortedRows.reduce((acc, r) => acc + N(r?.cgstTotal), 0),
        ),
        sgstTotal: round2(
          sortedRows.reduce((acc, r) => acc + N(r?.sgstTotal), 0),
        ),
        igstTotal: round2(
          sortedRows.reduce((acc, r) => acc + N(r?.igstTotal), 0),
        ),
        roundOff: round2(
          sortedRows.reduce((acc, r) => acc + N(r?.roundOff), 0),
        ),
        grandTotal: round2(
          sortedRows.reduce((acc, r) => acc + N(r?.grandTotal), 0),
        ),
      },
    };
  });

  groups.sort((a, b) => {
    const ai = getMonthSortIndex(a.monthName);
    const bi = getMonthSortIndex(b.monthName);
    if (ai !== bi) return ai - bi;
    return a.monthLabel.localeCompare(b.monthLabel);
  });

  return groups;
}

function normalizeInvoiceRow(order = {}, supplierStateCode = "") {
  const party = order?.partyId || {};
  const partyStateCode = getPartyStateCode(party);

  return {
    order,
    invoiceNumber: buildInvoiceNumber(order?.invoiceId),
    invoiceDate: order?.date
      ? moment(dateOnly(order.date)).format("DD-MMM-YYYY")
      : "-",
    gstin: party?.gstNumber || "",
    receiverName: party?.CompanyName || "",
    placeOfSupply: party?.gstNumber
      ? `${party.gstNumber.slice(0, 2)}-${party.State || ""}`
      : `${party.State || ""}`,
    rate: round2(
      N(order?.maxGstPercentage ?? order?.gstPercentage ?? order?.GSTRate),
    ),
    taxableAmount: round2(
      N(
        order?.amount ??
          order?.Amount ??
          order?.taxableAmount ??
          order?.basicTotal ??
          order?.BasicTotal,
      ),
    ),
    cgstTotal: round2(N(order?.cgstTotal)),
    sgstTotal: round2(N(order?.sgstTotal)),
    igstTotal: round2(N(order?.igstTotal)),
    roundOff: round2(
      N(
        order?.roundOff ??
          order?.roundoff ??
          order?.RoundOff ??
          order?.round_off ??
          order?.Round_Off,
      ),
    ),
    grandTotal: round2(
      N(
        order?.grandTotal ??
          order?.GrandTotal ??
          order?.grand_total ??
          order?.totalAmount ??
          order?.TotalAmount,
      ),
    ),
    isInterState: isInterStateFromOrder(
      order,
      partyStateCode,
      supplierStateCode,
    ),
  };
}

function exportRowsAsPDF(rows, headers, fileName) {
  if (!rows.length) return;
  const doc = new jsPDF("landscape", "mm", "a4");
  doc.addImage(Logo, "JPEG", 10, 8, 40, 18);
  doc.setFontSize(14);
  doc.text(fileName, 14, 36);
  autoTable(doc, {
    head: [headers],
    body: rows.map((r) => headers.map((h) => toStr(r[h] ?? ""))),
    startY: 42,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [244, 247, 246], textColor: 15 },
  });
  doc.save(`${fileName.replace(/\s+/g, "_")}.pdf`);
}

function exportRowsAsCSV(rows, fileName) {
  if (!rows.length) return;
  const csv = Papa.unparse(rows);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName.replace(/\s+/g, "_")}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function exportRowsAsXLS(rows, fileName) {
  const ws = XLSX.utils.json_to_sheet(
    rows.length ? rows : [{ message: "No data" }],
  );
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${fileName.replace(/\s+/g, "_")}.xlsx`);
}

const GSTR1_B2_SHEET_HEADERS = [
  "Invoice No.",
  "Invoice Date",
  "Party Name",
  "GSTIN/UIN",
  "Place of Supply",
  "Rate",
  "Taxable Value",
  "CGST",
  "SGST",
  "IGST",
  "Round Off",
  "Grand Total",
];

const GSTR1_CDNR_SHEET_HEADERS = [
  "GSTIN/UIN of Recipient",
  "Receiver Name",
  "Note Number",
  "Note Date",
  "Note Type",
  "Place of Supply",
  "Note Value",
  "Rate",
  "Taxable Value",
  "CGST",
  "SGST",
  "IGST",
  "Round Off",
];

const GSTR1_CDNUR_SHEET_HEADERS = [
  "UR Type",
  "Receiver Name",
  "Note Number",
  "Note Date",
  "Note Type",
  "Place of Supply",
  "Note Value",
  "Rate",
  "Taxable Value",
  "CGST",
  "SGST",
  "IGST",
  "Round Off",
];

const GSTR1_COMBINED_HEADERS = [
  "Report Type",
  "Document Number",
  "Document Date",
  "Document Type",
  "Party Name",
  "GSTIN/UIN",
  "Place of Supply",
  "Rate",
  "Taxable Value",
  "CGST",
  "SGST",
  "IGST",
  "Round Off",
  "Document Value",
];

function getNoteParty(row = {}) {
  return row?.order?.partyId || row?.partyId || {};
}

function getNoteNumber(row = {}) {
  return (
    row?.invoiceNumber ||
    row?.noteNumber ||
    row?.creditNoteNumber ||
    row?.debitNoteNumber ||
    buildInvoiceNumber(row?.invoiceId || row?.order?.invoiceId)
  );
}

function getNoteDate(row = {}) {
  const raw = row?.order?.date || row?.date || row?.createdAt;
  return raw ? moment(dateOnly(raw)).format("DD-MMM-YYYY") : "-";
}

function getNoteType(row = {}) {
  return row?.order?.creditType || row?.creditType
    ? "Credit Note"
    : "Debit Note";
}

function getNoteTaxAmounts(row = {}) {
  return {
    taxable: round2(
      N(row?.taxableAmount ?? row?.TaxableAmount ?? row?.amount ?? row?.Amount),
    ),
    cgst: round2(
      N(row?.cgstTotal ?? row?.cgstAmount ?? row?.CGSTAmount ?? row?.cgst),
    ),
    sgst: round2(
      N(row?.sgstTotal ?? row?.sgstAmount ?? row?.SGSTAmount ?? row?.sgst),
    ),
    igst: round2(
      N(row?.igstTotal ?? row?.igstAmount ?? row?.IGSTAmount ?? row?.igst),
    ),
    roundOff: round2(
      N(
        row?.roundOff ?? row?.roundoff ?? row?.RoundOff ?? row?.order?.roundOff,
      ),
    ),
    total: round2(
      N(
        row?.invoiceValue ??
          row?.grandTotal ??
          row?.GrandTotal ??
          row?.order?.grandTotal,
      ),
    ),
  };
}

function buildGstr1B2SheetRows(rows = []) {
  return rows.map((r) => ({
    "Invoice No.": r?.invoiceNumber || "",
    "Invoice Date": r?.invoiceDate || "",
    "Party Name": r?.receiverName || "",
    "GSTIN/UIN": r?.gstin || "",
    "Place of Supply": r?.placeOfSupply || "",
    Rate: round2(r?.rate),
    "Taxable Value": round2(r?.taxableAmount),
    CGST: round2(r?.cgstTotal),
    SGST: round2(r?.sgstTotal),
    IGST: round2(r?.igstTotal),
    "Round Off": round2(r?.roundOff),
    "Grand Total": round2(r?.grandTotal),
  }));
}

function buildGstr1NoteSheetRows(rows = [], reportType = "CDNR") {
  return rows.map((r) => {
    const party = getNoteParty(r);
    const tax = getNoteTaxAmounts(r);
    const common = {
      "Receiver Name": party?.CompanyName || party?.name || "",
      "Note Number": getNoteNumber(r),
      "Note Date": getNoteDate(r),
      "Note Type": getNoteType(r),
      "Place of Supply": r?.placeOfSupply || party?.State || "",
      "Note Value": tax.total,
      Rate: round2(r?.GSTRate),
      "Taxable Value": tax.taxable,
      CGST: tax.cgst,
      SGST: tax.sgst,
      IGST: tax.igst,
      "Round Off": tax.roundOff,
    };

    if (reportType === "CDNR") {
      return {
        "GSTIN/UIN of Recipient": party?.gstNumber || "",
        ...common,
      };
    }

    return {
      "UR Type": "B2CL",
      ...common,
    };
  });
}

function buildGstr1CombinedB2Rows(reportType, rows = []) {
  return rows.map((r) => ({
    "Report Type": reportType,
    "Document Number": r?.invoiceNumber || "",
    "Document Date": r?.invoiceDate || "",
    "Document Type": "Invoice",
    "Party Name": r?.receiverName || "",
    "GSTIN/UIN": r?.gstin || "",
    "Place of Supply": r?.placeOfSupply || "",
    Rate: round2(r?.rate),
    "Taxable Value": round2(r?.taxableAmount),
    CGST: round2(r?.cgstTotal),
    SGST: round2(r?.sgstTotal),
    IGST: round2(r?.igstTotal),
    "Round Off": round2(r?.roundOff),
    "Document Value": round2(r?.grandTotal),
  }));
}

function buildGstr1CombinedNoteRows(reportType, rows = []) {
  return rows.map((r) => {
    const party = getNoteParty(r);
    const tax = getNoteTaxAmounts(r);

    return {
      "Report Type": reportType,
      "Document Number": getNoteNumber(r),
      "Document Date": getNoteDate(r),
      "Document Type": getNoteType(r),
      "Party Name": party?.CompanyName || party?.name || "",
      "GSTIN/UIN": party?.gstNumber || "",
      "Place of Supply": r?.placeOfSupply || party?.State || "",
      Rate: round2(r?.GSTRate),
      "Taxable Value": tax.taxable,
      CGST: tax.cgst,
      SGST: tax.sgst,
      IGST: tax.igst,
      "Round Off": tax.roundOff,
      "Document Value": tax.total,
    };
  });
}

function appendGstr1Sheet(workbook, sheetName, rows, headers) {
  const worksheet = rows.length
    ? XLSX.utils.json_to_sheet(rows, { header: headers })
    : XLSX.utils.aoa_to_sheet([headers]);

  worksheet["!cols"] = headers.map((header) => {
    const maxValueLength = rows.reduce(
      (max, row) => Math.max(max, toStr(row?.[header]).length),
      header.length,
    );
    return { wch: Math.min(Math.max(maxValueLength + 2, 12), 38) };
  });

  worksheet["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: Math.max(rows.length, 1), c: headers.length - 1 },
    }),
  };

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
}

function downloadGstr1Workbook({
  b2bRows,
  b2csRows,
  b2clRows,
  cdnrRows,
  cdnurRows,
  rangeLabel,
}) {
  const b2bSheetRows = buildGstr1B2SheetRows(b2bRows);
  const b2csSheetRows = buildGstr1B2SheetRows(b2csRows);
  const b2clSheetRows = buildGstr1B2SheetRows(b2clRows);
  const cdnrSheetRows = buildGstr1NoteSheetRows(cdnrRows, "CDNR");
  const cdnurSheetRows = buildGstr1NoteSheetRows(cdnurRows, "CDNUR");

  const combinedRows = [
    ...buildGstr1CombinedB2Rows("B2B", b2bRows),
    ...buildGstr1CombinedB2Rows("B2CS", b2csRows),
    ...buildGstr1CombinedB2Rows("B2CL", b2clRows),
    ...buildGstr1CombinedNoteRows("CDNR", cdnrRows),
    ...buildGstr1CombinedNoteRows("CDNUR", cdnurRows),
  ];

  const workbook = XLSX.utils.book_new();

  appendGstr1Sheet(
    workbook,
    "Combined List",
    combinedRows,
    GSTR1_COMBINED_HEADERS,
  );
  appendGstr1Sheet(workbook, "B2B", b2bSheetRows, GSTR1_B2_SHEET_HEADERS);
  appendGstr1Sheet(workbook, "B2CS", b2csSheetRows, GSTR1_B2_SHEET_HEADERS);
  appendGstr1Sheet(workbook, "B2CL", b2clSheetRows, GSTR1_B2_SHEET_HEADERS);
  appendGstr1Sheet(workbook, "CDNR", cdnrSheetRows, GSTR1_CDNR_SHEET_HEADERS);
  appendGstr1Sheet(
    workbook,
    "CDNUR",
    cdnurSheetRows,
    GSTR1_CDNUR_SHEET_HEADERS,
  );

  const safeRange = toStr(rangeLabel || "Current_Filter")
    .replace(/[^a-z0-9-]+/gi, "_")
    .replace(/^_+|_+$/g, "");

  XLSX.writeFile(workbook, `GSTR1_${safeRange || "Current_Filter"}.xlsx`);
}

const COLS_B2 = [
  { key: "invoice", name: "Invoice No." },
  { key: "date", name: "Invoice Date" },
  { key: "party", name: "Party Name" },
  { key: "gst", name: "GSTIN/UIN" },
  { key: "pos", name: "Place of Supply" },
  { key: "rate", name: "Rate" },
  { key: "taxable", name: "Taxable Value" },
  { key: "cgst", name: "CGST" },
  { key: "sgst", name: "SGST" },
  { key: "igst", name: "IGST" },
  { key: "roundOff", name: "Round Off" },
  { key: "grand", name: "Grand Total" },
];

const COLS_CDNR = [
  {
    key: "gst",
    name: "GSTIN/UIN of Recipient",
    get: (r) => r?.order?.partyId?.gstNumber,
  },
  {
    key: "name",
    name: "Receiver Name",
    get: (r) => r?.order?.partyId?.CompanyName,
  },
  { key: "note", name: "Note Number", get: (r) => r?.invoiceNumber },
  {
    key: "date",
    name: "Note Date",
    get: (r) =>
      r?.order?.date
        ? moment(dateOnly(r.order.date)).format("DD-MMM-YYYY")
        : "-",
  },
  {
    key: "type",
    name: "Note Type",
    get: (r) => (r?.order?.creditType ? "C" : "D"),
  },
  { key: "pos", name: "Place of Supply", get: (r) => r?.placeOfSupply || "" },
  {
    key: "val",
    name: "Note Value",
    get: (r) => r?.invoiceValue ?? r?.grandTotal,
  },
  { key: "rate", name: "Rate", get: (r) => r?.GSTRate },
  {
    key: "tax",
    name: "Taxable Value",
    get: (r) =>
      r?.taxableAmount != null ? round2(r.taxableAmount).toFixed(2) : "",
  },
];

const COLS_CDNUR = [
  { key: "ur", name: "UR Type", get: () => "B2CL" },
  { key: "note", name: "Note Number", get: (r) => r?.invoiceNumber },
  {
    key: "date",
    name: "Note Date",
    get: (r) =>
      r?.order?.date
        ? moment(dateOnly(r.order.date)).format("DD-MMM-YYYY")
        : "-",
  },
  {
    key: "type",
    name: "Note Type",
    get: (r) => (r?.order?.creditType ? "C" : "D"),
  },
  { key: "pos", name: "Place of Supply", get: (r) => r?.placeOfSupply || "" },
  {
    key: "val",
    name: "Note Value",
    get: (r) => r?.invoiceValue ?? r?.grandTotal,
  },
  { key: "rate", name: "Rate", get: (r) => r?.GSTRate },
  {
    key: "tax",
    name: "Taxable Value",
    get: (r) =>
      r?.taxableAmount != null ? round2(r.taxableAmount).toFixed(2) : "",
  },
];

function buildB2ExportRows(title, groupedRows) {
  const out = [];

  groupedRows.forEach((group) => {
    out.push({
      Section: title,
      Month: group.monthLabel,
      "Invoice No.": "MONTH TOTAL",
      "Invoice Date": "",
      "Party Name": "",
      "GSTIN/UIN": "",
      "Place of Supply": "",
      Rate: "",
      "Taxable Value": money(group.totals.taxableAmount),
      CGST: money(group.totals.cgstTotal),
      SGST: money(group.totals.sgstTotal),
      IGST: money(group.totals.igstTotal),
      "Round Off": money(group.totals.roundOff),
      "Grand Total": money(group.totals.grandTotal),
    });

    group.rows.forEach((r) => {
      out.push({
        Section: title,
        Month: group.monthLabel,
        "Invoice No.": r.invoiceNumber,
        "Invoice Date": r.invoiceDate,
        "Party Name": r.receiverName,
        "GSTIN/UIN": r.gstin,
        "Place of Supply": r.placeOfSupply,
        Rate: money(r.rate),
        "Taxable Value": money(r.taxableAmount),
        CGST: money(r.cgstTotal),
        SGST: money(r.sgstTotal),
        IGST: money(r.igstTotal),
        "Round Off": money(r.roundOff),
        "Grand Total": money(r.grandTotal),
      });
    });
  });

  const finalTotals = groupedRows.reduce(
    (acc, g) => {
      acc.taxable += N(g.totals.taxableAmount);
      acc.cgst += N(g.totals.cgstTotal);
      acc.sgst += N(g.totals.sgstTotal);
      acc.igst += N(g.totals.igstTotal);
      acc.roundOff += N(g.totals.roundOff);
      acc.grand += N(g.totals.grandTotal);
      return acc;
    },
    { taxable: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, grand: 0 },
  );

  out.push({
    Section: title,
    Month: "",
    "Invoice No.": "FINAL TOTAL",
    "Invoice Date": "",
    "Party Name": "",
    "GSTIN/UIN": "",
    "Place of Supply": "",
    Rate: "",
    "Taxable Value": money(finalTotals.taxable),
    CGST: money(finalTotals.cgst),
    SGST: money(finalTotals.sgst),
    IGST: money(finalTotals.igst),
    "Round Off": money(finalTotals.roundOff),
    "Grand Total": money(finalTotals.grand),
  });

  return out;
}

function B2MonthSection({
  title,
  rows,
  monthOpenMap,
  toggleMonth,
  fyStartYear,
  onOpenInvoice,
}) {
  const [downloadOpen, setDownloadOpen] = useState(false);

  const groupedRows = useMemo(
    () => groupRowsByMonth(rows, fyStartYear, title),
    [rows, fyStartYear, title],
  );

  const finalTotals = useMemo(
    () =>
      groupedRows.reduce(
        (acc, g) => {
          acc.taxable += N(g.totals.taxableAmount);
          acc.cgst += N(g.totals.cgstTotal);
          acc.sgst += N(g.totals.sgstTotal);
          acc.igst += N(g.totals.igstTotal);
          acc.roundOff += N(g.totals.roundOff);
          acc.grand += N(g.totals.grandTotal);
          return acc;
        },
        { taxable: 0, cgst: 0, sgst: 0, igst: 0, roundOff: 0, grand: 0 },
      ),
    [groupedRows],
  );

  const exportRows = useMemo(
    () => buildB2ExportRows(title, groupedRows),
    [title, groupedRows],
  );

  const headers = [
    "Section",
    "Month",
    "Invoice No.",
    "Invoice Date",
    "Party Name",
    "GSTIN/UIN",
    "Place of Supply",
    "Rate",
    "Taxable Value",
    "CGST",
    "SGST",
    "IGST",
    "Round Off",
    "Grand Total",
  ];

  return (
    <>
      <div className="g1-section-title">
        {title}
        <span className="pill">{rows.length}</span>
        <div style={{ flex: 1 }} />
        <div
          className="g1-dl"
          onMouseEnter={() => setDownloadOpen(true)}
          onMouseLeave={() => setDownloadOpen(false)}
        >
          <ImDownload
            style={{ cursor: "pointer" }}
            size={18}
            color="rgb(8,91,245)"
          />
          {downloadOpen && (
            <div className="g1-dl-menu">
              <div
                className="g1-dl-item"
                onClick={() =>
                  exportRowsAsPDF(exportRows, headers, `${title}_GSTR1`)
                }
              >
                .PDF
              </div>
              <div
                className="g1-dl-item"
                onClick={() => exportRowsAsCSV(exportRows, `${title}_GSTR1`)}
              >
                .CSV
              </div>
              <div
                className="g1-dl-item"
                onClick={() => exportRowsAsXLS(exportRows, `${title}_GSTR1`)}
              >
                .XLS
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="g1-table-wrap">
        <table className="g1-table">
          <thead>
            <tr>
              <th>#</th>
              {COLS_B2.map((c) => (
                <th key={c.key}>{c.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!groupedRows.length ? (
              <tr>
                <td
                  colSpan={COLS_B2.length + 1}
                  style={{ padding: 16, color: "#6b7280" }}
                >
                  No records
                </td>
              </tr>
            ) : (
              groupedRows.map((group) => (
                <React.Fragment key={group.key}>
                  <tr
                    className="g1-month-row"
                    onClick={() => toggleMonth(group.key)}
                  >
                    <td>
                      <div className="g1-month-cell">
                        {monthOpenMap[group.key] ? (
                          <FaChevronDown />
                        ) : (
                          <FaChevronRight />
                        )}
                        <span>{group.monthLabel}</span>
                      </div>
                    </td>

                    {COLS_B2.map((c) => {
                      if (c.key === "party" || c.key === "gst") {
                        return (
                          <td key={c.key}>
                            <span className="g1-month-muted">Month Total</span>
                          </td>
                        );
                      }
                      if (c.key === "taxable") {
                        return (
                          <td key={c.key}>
                            {money(group.totals.taxableAmount)}
                          </td>
                        );
                      }
                      if (c.key === "cgst") {
                        return (
                          <td key={c.key}>{money(group.totals.cgstTotal)}</td>
                        );
                      }
                      if (c.key === "sgst") {
                        return (
                          <td key={c.key}>{money(group.totals.sgstTotal)}</td>
                        );
                      }
                      if (c.key === "igst") {
                        return (
                          <td key={c.key}>{money(group.totals.igstTotal)}</td>
                        );
                      }
                      if (c.key === "roundOff") {
                        return (
                          <td key={c.key}>{money(group.totals.roundOff)}</td>
                        );
                      }
                      if (c.key === "grand") {
                        return (
                          <td key={c.key}>{money(group.totals.grandTotal)}</td>
                        );
                      }
                      return <td key={c.key} />;
                    })}
                  </tr>

                  {monthOpenMap[group.key] &&
                    group.rows.map((r, idx) => (
                      <tr key={`${group.key}-${r?.order?._id || idx}`}>
                        <td>{idx + 1}</td>
                        <td>
                          <span
                            className="g1-link"
                            title="Open Invoice"
                            onClick={() => onOpenInvoice(r)}
                          >
                            {r.invoiceNumber}
                          </span>
                        </td>
                        <td>{r.invoiceDate}</td>
                        <td>{r.receiverName}</td>
                        <td>{r.gstin || "-"}</td>
                        <td>{r.placeOfSupply || "-"}</td>
                        <td>{money(r.rate)}</td>
                        <td>{money(r.taxableAmount)}</td>
                        <td>{money(r.cgstTotal)}</td>
                        <td>{money(r.sgstTotal)}</td>
                        <td>{money(r.igstTotal)}</td>
                        <td>{money(r.roundOff)}</td>
                        <td>{money(r.grandTotal)}</td>
                      </tr>
                    ))}
                </React.Fragment>
              ))
            )}

            {!!groupedRows.length && (
              <tr className="g1-final-row">
                <td />
                {COLS_B2.map((c) => {
                  if (c.key === "party" || c.key === "gst") {
                    return <td key={c.key}>Final Total</td>;
                  }
                  if (c.key === "taxable") {
                    return <td key={c.key}>{money(finalTotals.taxable)}</td>;
                  }
                  if (c.key === "cgst") {
                    return <td key={c.key}>{money(finalTotals.cgst)}</td>;
                  }
                  if (c.key === "sgst") {
                    return <td key={c.key}>{money(finalTotals.sgst)}</td>;
                  }
                  if (c.key === "igst") {
                    return <td key={c.key}>{money(finalTotals.igst)}</td>;
                  }
                  if (c.key === "roundOff") {
                    return <td key={c.key}>{money(finalTotals.roundOff)}</td>;
                  }
                  if (c.key === "grand") {
                    return <td key={c.key}>{money(finalTotals.grand)}</td>;
                  }
                  return <td key={c.key} />;
                })}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

function buildNoteExportRows(title, rows, cols) {
  return rows.map((r, i) => {
    const obj = { "#": r?.__summary ? "" : i + 1 };
    cols.forEach((c) => {
      if (r?.__summary) {
        if (c.key === "name" || c.key === "gst") obj[c.name] = "Total";
        else if (["tax", "val"].includes(c.key))
          obj[c.name] = money(r?.taxableAmount || r?.invoiceValue || 0);
        else obj[c.name] = "";
      } else {
        obj[c.name] = toStr(c.get(r) ?? "");
      }
    });
    return obj;
  });
}

function NoteSection({ title, rows, cols }) {
  const [downloadOpen, setDownloadOpen] = useState(false);
  const exportRows = useMemo(
    () => buildNoteExportRows(title, rows, cols),
    [title, rows, cols],
  );
  const headers = exportRows.length ? Object.keys(exportRows[0]) : ["#"];

  const renderCell = (col, r) => {
    if (r?.__summary) {
      if (col.key === "name" || col.key === "gst")
        return <strong>Total</strong>;
      if (["tax", "val"].includes(col.key)) {
        return (
          <strong>{money(r?.taxableAmount || r?.invoiceValue || 0)}</strong>
        );
      }
      return "";
    }
    return toStr(col.get(r) ?? "");
  };

  return (
    <>
      <div className="g1-section-title">
        {title}
        <span className="pill">{rows.length ? rows.length - 1 : 0}</span>
        <div style={{ flex: 1 }} />
        <div
          className="g1-dl"
          onMouseEnter={() => setDownloadOpen(true)}
          onMouseLeave={() => setDownloadOpen(false)}
        >
          <ImDownload
            style={{ cursor: "pointer" }}
            size={18}
            color="rgb(8,91,245)"
          />
          {downloadOpen && (
            <div className="g1-dl-menu">
              <div
                className="g1-dl-item"
                onClick={() =>
                  exportRowsAsPDF(exportRows, headers, `${title}_GSTR1`)
                }
              >
                .PDF
              </div>
              <div
                className="g1-dl-item"
                onClick={() => exportRowsAsCSV(exportRows, `${title}_GSTR1`)}
              >
                .CSV
              </div>
              <div
                className="g1-dl-item"
                onClick={() => exportRowsAsXLS(exportRows, `${title}_GSTR1`)}
              >
                .XLS
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="g1-table-wrap">
        <table className="g1-table">
          <thead>
            <tr>
              <th>#</th>
              {cols.map((c) => (
                <th key={c.key}>{c.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length ? (
              rows.map((r, i) => (
                <tr
                  key={
                    r?._id || (r.__summary ? `sum-${title}` : `${title}-${i}`)
                  }
                >
                  <td>{r?.__summary ? "" : i + 1}</td>
                  {cols.map((c) => (
                    <td key={c.key}>{renderCell(c, r)}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={cols.length + 1}
                  style={{ padding: 16, color: "#6b7280" }}
                >
                  No records
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default function GSTR1() {
  const [loading, setLoading] = useState(true);
  const [perm, setPerm] = useState({ View: true, Download: true });
  const [masterShow, setMasterShow] = useState(false);

  const [activeTab, setActiveTab] = useState("B2");
  const [filterType, setFilterType] = useState("month");
  const [fyStartYear] = useState(getSelectedFYStartYear());
  const [month, setMonth] = useState(4);
  const [quarter, setQuarter] = useState("Q1");
  const [half, setHalf] = useState("H1");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [b2bInvoices, setB2bInvoices] = useState([]);
  const [b2csInvoices, setB2csInvoices] = useState([]);
  const [b2clInvoices, setB2clInvoices] = useState([]);
  const [completedOrdersForCompare, setCompletedOrdersForCompare] = useState(
    [],
  );
  const [cdnurList, setCdnurList] = useState([]);
  const [supplierStateCode, setSupplierStateCode] = useState("");

  const [search, setSearch] = useState("");
  const deferredSearch = useDeferredValue(search);

  const [viewOpen, setViewOpen] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [wordsNumber, setWordsNumber] = useState("");
  const [monthOpenMap, setMonthOpenMap] = useState({});

  useEffect(() => injectOnce(), []);

  useEffect(() => {
    (async () => {
      try {
        const user = JSON.parse(localStorage.getItem("userData") || "{}");
        if (user?.rolename?.roleName === "MASTER") setMasterShow(true);
        setPerm(CheckPermission("GSTR 1") || { View: true, Download: true });

        const suppCode = getSupplierStateCode();
        setSupplierStateCode(suppCode);

        const selectedDatabase = getSelectedDatabase(user);

        if (!selectedDatabase) {
          throw new Error("Database not found for selected financial year.");
        }

        const b2Res = await createOrderhistoryviewDATABASE(selectedDatabase);

        const onlyCompletedInvoices = (list = []) =>
          Array.isArray(list)
            ? list.filter((x) => isCompletedStatus(x?.status))
            : [];

        const rawB2B = onlyCompletedInvoices(b2Res?.b2bData);
        const rawB2CS = onlyCompletedInvoices(b2Res?.b2csData);
        const rawB2CL = onlyCompletedInvoices(b2Res?.b2clData);

        const allBucketInvoices = [...rawB2B, ...rawB2CS, ...rawB2CL];

        setB2bInvoices(rawB2B);
        setB2csInvoices(rawB2CS);
        setB2clInvoices(rawB2CL);
        setCompletedOrdersForCompare(allBucketInvoices);

        const cdnrApi = await safeCDNR(user?._id, user?.database);
        setCdnurList(
          (cdnrApi || []).map((el) => {
            const party = el?.order?.partyId || {};
            const partyStateCode = getPartyStateCode(party);
            const isInterState = isInterStateFromOrder(
              el?.order,
              partyStateCode,
              suppCode,
            );
            return {
              ...el,
              placeOfSupply: party?.gstNumber
                ? `${party.gstNumber.slice(0, 2)}-${party.State || ""}`
                : `${party.State || ""}`,
              invoiceValue: round2(N(el?.grandTotal ?? el?.order?.grandTotal)),
              GSTRate:
                N(el?.productId?.GSTRate) ||
                N(el?.gstPercentage) ||
                N(el?.cgstRate) + N(el?.sgstRate) + N(el?.igstRate),
              isInterState,
              invoiceNumber: buildInvoiceNumber(
                el?.order?.invoiceId || el?.invoiceId,
              ),
            };
          }),
        );
      } catch (e) {
        console.error(e);
        swal("Error", "Failed to load GSTR-1 data");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const b2FilterPred = useMemo(() => {
    return (order) =>
      inFinancialPeriod(
        order?.date || order?.createdAt || order?.updatedAt,
        fyStartYear,
        filterType,
        month,
        quarter,
        half,
        startDate,
        endDate,
      );
  }, [fyStartYear, filterType, month, quarter, half, startDate, endDate]);

  const orderComparePred = useMemo(() => {
    return (order) =>
      inFinancialPeriod(
        order?.date || order?.createdAt || order?.updatedAt,
        fyStartYear,
        filterType,
        month,
        quarter,
        half,
        startDate,
        endDate,
      );
  }, [fyStartYear, filterType, month, quarter, half, startDate, endDate]);

  const cdnrFilterPred = useMemo(() => {
    return (row) =>
      inFinancialPeriod(
        row?.order?.date || row?.date,
        fyStartYear,
        filterType,
        month,
        quarter,
        half,
        startDate,
        endDate,
      );
  }, [fyStartYear, filterType, month, quarter, half, startDate, endDate]);

  const b2SearchPred = useMemo(() => {
    const term = deferredSearch.trim().toLowerCase();
    if (!term) return () => true;

    return (r) =>
      [
        r?.invoiceNumber,
        r?.receiverName,
        r?.gstin,
        r?.placeOfSupply,
        r?.taxableAmount,
        r?.grandTotal,
      ]
        .map(toStr)
        .join(" ")
        .toLowerCase()
        .includes(term);
  }, [deferredSearch]);

  const noteSearchPred = useMemo(() => {
    const term = deferredSearch.trim().toLowerCase();
    if (!term) return () => true;

    return (r) =>
      [
        r?.invoiceNumber,
        r?.order?.partyId?.CompanyName,
        r?.order?.partyId?.gstNumber,
        r?.placeOfSupply,
        r?.GSTRate,
        r?.taxableAmount,
        r?.invoiceValue,
      ]
        .map(toStr)
        .join(" ")
        .toLowerCase()
        .includes(term);
  }, [deferredSearch]);

  const b2bRows = useMemo(
    () =>
      b2bInvoices
        .filter(b2FilterPred)
        .map((o) => normalizeInvoiceRow(o, supplierStateCode))
        .filter(b2SearchPred),
    [b2bInvoices, b2FilterPred, supplierStateCode, b2SearchPred],
  );

  const b2csRows = useMemo(
    () =>
      b2csInvoices
        .filter(b2FilterPred)
        .map((o) => normalizeInvoiceRow(o, supplierStateCode))
        .filter(b2SearchPred),
    [b2csInvoices, b2FilterPred, supplierStateCode, b2SearchPred],
  );

  const b2clRows = useMemo(
    () =>
      b2clInvoices
        .filter(b2FilterPred)
        .map((o) => normalizeInvoiceRow(o, supplierStateCode))
        .filter(b2SearchPred),
    [b2clInvoices, b2FilterPred, supplierStateCode, b2SearchPred],
  );

  const combinedTotals = useMemo(() => {
    const all = [...b2bRows, ...b2clRows, ...b2csRows];
    return {
      taxable: round2(all.reduce((acc, r) => acc + N(r?.taxableAmount), 0)),
      cgst: round2(all.reduce((acc, r) => acc + N(r?.cgstTotal), 0)),
      sgst: round2(all.reduce((acc, r) => acc + N(r?.sgstTotal), 0)),
      igst: round2(all.reduce((acc, r) => acc + N(r?.igstTotal), 0)),
      roundOff: round2(all.reduce((acc, r) => acc + N(r?.roundOff), 0)),
      grand: round2(all.reduce((acc, r) => acc + N(r?.grandTotal), 0)),
    };
  }, [b2bRows, b2clRows, b2csRows]);

  const completedPageTotals = useMemo(() => {
    const list = completedOrdersForCompare.filter(orderComparePred);
    return {
      taxable: round2(
        list.reduce(
          (acc, o) =>
            acc +
            N(
              o?.amount ??
                o?.Amount ??
                o?.taxableAmount ??
                o?.basicTotal ??
                o?.BasicTotal,
            ),
          0,
        ),
      ),
      cgst: round2(list.reduce((acc, r) => acc + N(r?.cgstTotal), 0)),
      sgst: round2(list.reduce((acc, r) => acc + N(r?.sgstTotal), 0)),
      igst: round2(list.reduce((acc, r) => acc + N(r?.igstTotal), 0)),
      roundOff: round2(
        list.reduce(
          (acc, r) =>
            acc +
            N(
              r?.roundOff ??
                r?.roundoff ??
                r?.RoundOff ??
                r?.round_off ??
                r?.Round_Off,
            ),
          0,
        ),
      ),
      grand: round2(
        list.reduce(
          (acc, r) =>
            acc +
            N(
              r?.grandTotal ??
                r?.GrandTotal ??
                r?.grand_total ??
                r?.totalAmount ??
                r?.TotalAmount,
            ),
          0,
        ),
      ),
    };
  }, [completedOrdersForCompare, orderComparePred]);

  const hasMismatch = useMemo(() => {
    const eps = 0.5;
    const diffs = [
      Math.abs(combinedTotals.taxable - completedPageTotals.taxable),
      Math.abs(combinedTotals.roundOff - completedPageTotals.roundOff),
      Math.abs(combinedTotals.cgst - completedPageTotals.cgst),
      Math.abs(combinedTotals.sgst - completedPageTotals.sgst),
      Math.abs(combinedTotals.igst - completedPageTotals.igst),
      Math.abs(combinedTotals.grand - completedPageTotals.grand),
    ];
    return diffs.some((d) => d > eps);
  }, [combinedTotals, completedPageTotals]);

  const filteredCdnRows = useMemo(
    () => cdnurList.filter(cdnrFilterPred).filter(noteSearchPred),
    [cdnurList, cdnrFilterPred, noteSearchPred],
  );

  const cdnrRows = useMemo(
    () =>
      filteredCdnRows.filter((r) =>
        Boolean(toStr(getNoteParty(r)?.gstNumber).trim()),
      ),
    [filteredCdnRows],
  );

  const cdnurRows = useMemo(
    () =>
      filteredCdnRows.filter(
        (r) => !Boolean(toStr(getNoteParty(r)?.gstNumber).trim()),
      ),
    [filteredCdnRows],
  );

  const addNoteSummary = (list) => {
    if (!list.length) return [];

    return [
      ...list,
      {
        taxableAmount: round2(
          list.reduce((acc, r) => acc + N(r?.taxableAmount), 0),
        ),
        invoiceValue: round2(
          list.reduce((acc, r) => acc + N(r?.invoiceValue), 0),
        ),
        __summary: true,
      },
    ];
  };

  const cdnrActiveList = useMemo(() => addNoteSummary(cdnrRows), [cdnrRows]);
  const cdnurActiveList = useMemo(() => addNoteSummary(cdnurRows), [cdnurRows]);

  const currentRangeLabel = useMemo(
    () =>
      formatCurrentRangeLabel(
        filterType,
        fyStartYear,
        month,
        quarter,
        half,
        startDate,
        endDate,
      ),
    [filterType, fyStartYear, month, quarter, half, startDate, endDate],
  );

  const handleDownloadGstr1 = () => {
    try {
      downloadGstr1Workbook({
        b2bRows,
        b2csRows,
        b2clRows,
        cdnrRows,
        cdnurRows,
        rangeLabel: currentRangeLabel,
      });
    } catch (error) {
      console.error(error);
      swal("Error", "Unable to download GSTR-1 Excel");
    }
  };

  useEffect(() => {
    const next = {};
    groupRowsByMonth(b2bRows, fyStartYear, "B2B").forEach((g) => {
      next[g.key] = false;
    });
    groupRowsByMonth(b2clRows, fyStartYear, "B2CL").forEach((g) => {
      next[g.key] = false;
    });
    groupRowsByMonth(b2csRows, fyStartYear, "B2CS").forEach((g) => {
      next[g.key] = false;
    });
    setMonthOpenMap(next);
  }, [b2bRows, b2clRows, b2csRows, fyStartYear]);

  const toggleMonth = (key) => {
    setMonthOpenMap((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const openInvoice = async (row) => {
    try {
      const invoiceId = row?.order?.invoiceId;
      if (!invoiceId) return swal("Invoice ID not found");

      const user = JSON.parse(localStorage.getItem("userData") || "{}");
      const res = await _GetById(
        View_Invoice_Data_by_id,
        user?.database,
        invoiceId,
      );

      const print = res?.printData;
      if (!print) return swal("Invoice data not found");

      setPrintData(print);
      setViewOpen(true);

      const grand =
        N(print?.grandTotal) ||
        N(print?.order?.grandTotal) ||
        N(row?.grandTotal);

      const t = new ToWords();
      setWordsNumber(t.convert(grand, { currency: true }));
    } catch (e) {
      console.error(e);
      swal("Error", "Unable to open invoice");
    }
  };

  const onFilterTypeChange = (v) => {
    setFilterType(v);
    if (v === "month") setMonth(4);
    if (v === "quarter") setQuarter("Q1");
    if (v === "half") setHalf("H1");
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20rem",
        }}
      >
        <Spinner style={{ height: "4rem", width: "4rem" }} color="primary">
          Loading...
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <Row className="mt-1">
        <Col sm="12">
          <Card className="g1-card">
            <div className="g1-toolbar">
              <div className="g1-tabs">
                {["B2", "CDNR", "CDNUR"].map((id) => (
                  <div
                    key={id}
                    className={`g1-tab ${activeTab === id ? "active" : ""}`}
                    onClick={() => setActiveTab(id)}
                  >
                    {id === "B2" ? "B2 (B2B / B2CL / B2CS)" : id}
                  </div>
                ))}
              </div>

              {masterShow ? (
                <div style={{ minWidth: 240 }}>
                  <SuperAdminUI
                    onDropdownChange={(v) =>
                      localStorage.setItem(
                        "SuperadminIdByMaster",
                        JSON.stringify(v),
                      )
                    }
                    onSubmit={(e) => {
                      e.preventDefault();
                      window.location.reload();
                    }}
                  />
                </div>
              ) : null}

              <div className="g1-field wide">
                <div className="g1-label">Filter Type</div>
                <Input
                  type="select"
                  className="g1-input"
                  value={filterType}
                  onChange={(e) => onFilterTypeChange(e.target.value)}
                >
                  <option value="date">Date Wise</option>
                  <option value="month">Monthly</option>
                  <option value="quarter">Quarterly</option>
                  <option value="half">Half Yearly</option>
                  <option value="year">Yearly</option>
                </Input>
              </div>

              {filterType === "date" && (
                <>
                  <div className="g1-field">
                    <div className="g1-label">Start</div>
                    <Input
                      type="date"
                      className="g1-input"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="g1-field">
                    <div className="g1-label">End</div>
                    <Input
                      type="date"
                      className="g1-input"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </>
              )}

              {filterType === "month" && (
                <div className="g1-field wide">
                  <div className="g1-label">Month</div>
                  <Input
                    type="select"
                    className="g1-input"
                    value={month}
                    onChange={(e) => setMonth(Number(e.target.value))}
                  >
                    {FY_MONTHS.map((m) => (
                      <option key={m.value} value={m.value}>
                        {m.label}
                      </option>
                    ))}
                  </Input>
                </div>
              )}

              {filterType === "quarter" && (
                <div className="g1-field wide">
                  <div className="g1-label">Quarter</div>
                  <Input
                    type="select"
                    className="g1-input"
                    value={quarter}
                    onChange={(e) => setQuarter(e.target.value)}
                  >
                    {FY_QUARTERS.map((q) => (
                      <option key={q.value} value={q.value}>
                        {q.label}
                      </option>
                    ))}
                  </Input>
                </div>
              )}

              {filterType === "half" && (
                <div className="g1-field wide">
                  <div className="g1-label">Half Year</div>
                  <Input
                    type="select"
                    className="g1-input"
                    value={half}
                    onChange={(e) => setHalf(e.target.value)}
                  >
                    {FY_HALVES.map((h) => (
                      <option key={h.value} value={h.value}>
                        {h.label}
                      </option>
                    ))}
                  </Input>
                </div>
              )}

              <div className="g1-spacer" />

              <Button
                color="primary"
                className="g1-download-gstr1"
                onClick={handleDownloadGstr1}
                disabled={perm?.Download === false}
                title={
                  perm?.Download === false
                    ? "You do not have download permission"
                    : "Download all GSTR-1 reports in one Excel workbook"
                }
              >
                <ImDownload size={15} />
                DOWNLOAD GSTR1
              </Button>

              <Input
                className="g1-input"
                style={{ width: 260, minWidth: 220 }}
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {activeTab === "B2" && hasMismatch && (
        <Row>
          <Col sm="12">
            <div className="g1-error">RUNNING ERROR</div>
          </Col>
        </Row>
      )}

      {activeTab === "B2" && (
        <>
          <Row>
            <Col sm="12">
              <div className="g1-sum-bar">
                <div className="g1-section-title" style={{ marginTop: 0 }}>
                  Combined Totals (Current Filter)
                </div>
                <div className="g1-sum-grid">
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">Grand Total</div>
                    <div className="g1-sum-v">
                      {money(combinedTotals.grand)}
                    </div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">Taxable Value</div>
                    <div className="g1-sum-v">
                      {money(combinedTotals.taxable)}
                    </div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">IGST</div>
                    <div className="g1-sum-v">{money(combinedTotals.igst)}</div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">CGST</div>
                    <div className="g1-sum-v">{money(combinedTotals.cgst)}</div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">SGST</div>
                    <div className="g1-sum-v">{money(combinedTotals.sgst)}</div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">Round Off</div>
                    <div className="g1-sum-v">
                      {money(combinedTotals.roundOff)}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <div className="g1-sum-bar">
                <div className="g1-section-title" style={{ marginTop: 0 }}>
                  Completed Orders Page Totals (for comparison)
                </div>
                <div className="g1-sum-grid">
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">Grand Total</div>
                    <div className="g1-sum-v">
                      {money(completedPageTotals.grand)}
                    </div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">Taxable Value</div>
                    <div className="g1-sum-v">
                      {money(completedPageTotals.taxable)}
                    </div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">IGST</div>
                    <div className="g1-sum-v">
                      {money(completedPageTotals.igst)}
                    </div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">CGST</div>
                    <div className="g1-sum-v">
                      {money(completedPageTotals.cgst)}
                    </div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">SGST</div>
                    <div className="g1-sum-v">
                      {money(completedPageTotals.sgst)}
                    </div>
                  </div>
                  <div className="g1-sum-box">
                    <div className="g1-sum-k">Round Off</div>
                    <div className="g1-sum-v">
                      {money(completedPageTotals.roundOff)}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </>
      )}

      {activeTab === "B2" ? (
        <Row className="mt-1">
          <Col sm="12">
            <Card className="g1-section-card">
              <B2MonthSection
                title="B2B"
                rows={b2bRows}
                monthOpenMap={monthOpenMap}
                toggleMonth={toggleMonth}
                fyStartYear={fyStartYear}
                onOpenInvoice={openInvoice}
              />

              <div style={{ height: 12 }} />

              <B2MonthSection
                title="B2CL"
                rows={b2clRows}
                monthOpenMap={monthOpenMap}
                toggleMonth={toggleMonth}
                fyStartYear={fyStartYear}
                onOpenInvoice={openInvoice}
              />

              <div style={{ height: 12 }} />

              <B2MonthSection
                title="B2CS"
                rows={b2csRows}
                monthOpenMap={monthOpenMap}
                toggleMonth={toggleMonth}
                fyStartYear={fyStartYear}
                onOpenInvoice={openInvoice}
              />
            </Card>
          </Col>
        </Row>
      ) : (
        <Row className="mt-1">
          <Col sm="12">
            <Card className="g1-section-card">
              <NoteSection
                title={activeTab}
                rows={activeTab === "CDNR" ? cdnrActiveList : cdnurActiveList}
                cols={activeTab === "CDNR" ? COLS_CDNR : COLS_CDNUR}
              />
            </Card>
          </Col>
        </Row>
      )}

      <Modal
        isOpen={viewOpen}
        toggle={() => setViewOpen(false)}
        className="modal-xl"
        backdrop="static"
        keyboard={false}
        style={{
          maxWidth: "90%",
          width: "90%",
          height: "90%",
          overflowY: "auto",
        }}
      >
        <ModalHeader toggle={() => setViewOpen(false)}>
          View Invoice
        </ModalHeader>
        <ModalBody style={{ padding: 0 }}>
          <div style={{ width: "100%", overflowX: "auto" }}>
            {printData ? (
              <LastestInvoice
                EWayBill={false}
                CompanyDetails={JSON.parse(
                  localStorage.getItem("Companydetail") || "{}",
                )}
                BillNumber={buildInvoiceNumber(printData?.invoiceId)}
                PrintData={printData}
                Applied_Charges={[]}
                AllbillMerged={[]}
                wordsNumber={wordsNumber}
                deliveryCharges={0}
                otherCharges={0}
                discount={0}
              />
            ) : (
              <div style={{ padding: 20, textAlign: "center" }}>Loading…</div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

async function safeCDNR(id, db) {
  try {
    const r = await _Post(CDNR_Report, db, id);
    return (
      r?.CDNR?.flatMap((el) =>
        (el?.productItems || []).map((val) => ({ ...val, order: el })),
      ) || []
    );
  } catch {
    return [];
  }
}
